export const PRODUCT_TO_DISPLAY_NAME = {
	confluence: 'Confluence',
	jira: 'Jira',
	'jira-software': 'Jira',
	'jira-product-discovery': 'Jira Product Discovery',
	loom: 'Loom',
};

export type Product = keyof typeof PRODUCT_TO_DISPLAY_NAME;

export const getProductDisplayName = (product: Product) => PRODUCT_TO_DISPLAY_NAME[product];
